import React from 'react'
import TenantGroup from '../Components/Chat/TenantGroup'

const TenantGroupChatPage = () => {
  return (
    <TenantGroup />
  )
}

export default TenantGroupChatPage